import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import s from './MilestoneProgressBar.styles';

const MilestoneProgressBar = ({
    milestoneDetails = {
        startDate: '',
        targetCompletionDate: '',
        completedDate: ''
    }
}) => {
    const { t } = useTranslation();
    const [ milestoneDates, setMilestoneDates ] = useState({
        targetStartDate: '',
        targetCompletionDate: '',
        completedDate: '',
        daysDelayed: 0,
        daysLeft: 0,
        targetCompletionPercentage: 0,
        delayPercentage: 0
    });
   
    useEffect(() =>{
        let completedPercentage = 0;
        let delayPercentage = 0;

        let daysLeft = 0;
        let daysDelayed = 0;

        const momentStartDate = milestoneDetails.startDate && moment(milestoneDetails.startDate, 'YYYY-MM-DD');
        const momentTargetEndDate = milestoneDetails.targetCompletionDate && moment(milestoneDetails.targetCompletionDate, 'YYYY-MM-DD');
        const momentCompletedDate = milestoneDetails.completedDate && moment(milestoneDetails.completedDate, 'YYYY-MM-DD');
        const momentCurrentSystemDate = moment(`${new Date().getFullYear()}-${new Date().getMonth()+1}-${new Date().getDate()}`, 'YYYY-MM-DD');

        const daysBetweenStartAndCompleted = momentCompletedDate?.diff(momentStartDate, 'days'); // negative means delay
        const daysBetweenEndAndSystemDate = momentTargetEndDate?.diff(momentCurrentSystemDate, 'days'); // negative means delay
        const daysBetweenStartAndEnd = momentTargetEndDate?.diff(momentStartDate, 'days'); // negative means cap not started
        const daysBetweenEndAndCompleted = momentTargetEndDate?.diff(momentCompletedDate, 'days'); // negative means delay
        
        if(milestoneDetails.completedDate){

            // Completed on time no delay <= End date
            if(daysBetweenEndAndCompleted >= 0){
                daysLeft = -1;
                completedPercentage = 100;
                delayPercentage = 0;
            }
            // completed after the target completion date have delay Competed date > End date
            else if(daysBetweenEndAndCompleted < 0){
                daysDelayed = daysBetweenEndAndCompleted;
                completedPercentage = ( Math.abs(daysBetweenStartAndEnd) / Math.abs(daysBetweenStartAndCompleted) ) * 100;
                delayPercentage = ( Math.abs(daysBetweenEndAndCompleted) / Math.abs(daysBetweenStartAndCompleted) ) * 100;
            }

            
        }else{
            
            const daysBetweenStartAndSystemDate = momentCurrentSystemDate?.diff(momentStartDate, 'days'); // negative means cap not started
            // in progress no delay Start date < System date < End date 
            if(daysBetweenStartAndSystemDate >= 0 && daysBetweenEndAndSystemDate >= 0){
                daysLeft = daysBetweenEndAndSystemDate;
                completedPercentage = ( daysBetweenStartAndSystemDate / daysBetweenStartAndEnd ) * 100;
                delayPercentage = 0;
            }// Still in delayed have delay End date < System date
            else if(daysBetweenEndAndSystemDate < 0){
                daysLeft = 0;
                daysDelayed = daysBetweenEndAndSystemDate;
                completedPercentage = ( daysBetweenStartAndEnd / daysBetweenStartAndSystemDate ) * 100;
                delayPercentage = ( Math.abs(daysBetweenEndAndSystemDate) / daysBetweenStartAndSystemDate ) * 100;
            }
        }

        setMilestoneDates({
            targetStartDate: momentStartDate?.format("DD-MMM-YYYY"),
            targetCompletionDate: momentTargetEndDate?.format("DD-MMM-YYYY"),
            completedDate: momentCompletedDate?.format("DD-MMM-YYYY"),
            daysDelayed,
            daysLeft,
            targetCompletionPercentage: completedPercentage,
            delayPercentage
        });

    }, [milestoneDetails]);
    
    return (
        <>
            <s.MilestoneProgressBarWrapper>
                
                <s.MilestoneLegend>
                    <s.StartDateWrapper  style={milestoneDates.daysLeft > 0 || milestoneDates.targetCompletionPercentage === 0 ? {width: `calc(100% - 175px)`} : {
                            width: `calc(${milestoneDates.targetCompletionPercentage}% - 175px)`
                        }}>
                        <s.Label>{t('CAP_START_DATE')} </s.Label>
                        <s.DateLabel> {milestoneDates.targetStartDate}</s.DateLabel>
                    </s.StartDateWrapper>
                    <s.TargetCompletionDateWrapper>
                        <s.Label>{t('CAP_TARGET_COMPLETION_DATE')} </s.Label>
                        <s.DateLabel> {milestoneDates.targetCompletionDate}</s.DateLabel>
                    </s.TargetCompletionDateWrapper>
                    { milestoneDetails.completedDate && 
                        <>
                           { milestoneDates.delayPercentage !== 0 && <s.DelayDaysWrapper  style={milestoneDates.delayPercentage === 100 ? {
                                width:  `75%`,
                                position: 'absolute'
                            } : {
                                width:  `${milestoneDates.delayPercentage}%`
                            }} >
                                <s.Label>{Math.abs(milestoneDates.daysDelayed)} {Math.abs(milestoneDates.daysDelayed) === 1 ? t('CAP_DAY_DELAY') : t('CAP_DAYS_DELAY')}</s.Label>
                            </s.DelayDaysWrapper> 
                            } 
                            <s.CompletedDateWrapper>
                                <s.Label>{t('COMPLETED')} </s.Label>
                                <s.DateLabel> {milestoneDates.completedDate}</s.DateLabel>
                            </s.CompletedDateWrapper>
                        </>
                    }
                    {!milestoneDetails.completedDate && ( milestoneDates.daysLeft <= 0 ?
                        <s.DelayDaysWrapper style={milestoneDates.delayPercentage === 100 ? {
                            width:  `75%`,
                            position: 'absolute'
                        } : {
                            width:  `${milestoneDates.delayPercentage}%`,
                            display: `${milestoneDates.delayPercentage === 0 ? 'none' : 'flex'}`
                        }} >
                            <s.Label>{Math.abs(milestoneDates.daysDelayed)} {Math.abs(milestoneDates.daysDelayed) === 1 ? t('CAP_DAY_DELAY') : t('CAP_DAYS_DELAY')}</s.Label>
                        </s.DelayDaysWrapper>
                    :                
                        <s.DaysLeftWrapper>
                            <s.Label style={{
                                    textAlign: 'center',
                            width: `${100 - milestoneDates.targetCompletionPercentage}%`
                        }}>{milestoneDates.daysLeft} {Math.abs(milestoneDates.daysLeft) === 1 ? t('CAP_DAY_LEFT') : t('CAP_DAYS_LEFT')}</s.Label>
                        </s.DaysLeftWrapper>
                    )
                }
                    
                </s.MilestoneLegend>
                <s.MilestoneProgressBarPart>

                    <s.MilestoneBar >
                        <s.MilestoneCompleted className={milestoneDates.daysLeft > 0 ? 'withOutDelay' : 'withDelay'} style={{
                            width: `${milestoneDates.targetCompletionPercentage}%`
                        }} />
                        <s.MilestoneDelay className={milestoneDates.daysLeft < 0 || milestoneDates.daysDelayed ? 'withDelay' : ''} style={{
                            width:  `${milestoneDates.delayPercentage}%`
                        }} />
                    </s.MilestoneBar>
                </s.MilestoneProgressBarPart>                   
                
            </s.MilestoneProgressBarWrapper>
        </>
    );
};

export default MilestoneProgressBar;
